// src/features/cloche/ChargeurCloche.tsx — SCE Issues
// Monté une fois (App.tsx) : tient la cloche à jour (03/11).
//
// - Lue au démarrage, puis toutes les 2 minutes tant que l'onglet est visible,
//   et dès qu'il le redevient après plus de 2 minutes caché.
// - Relue avec les listes (bouton Rafraîchir, fiche refermée après écriture).
// - La page ouverte efface les notifications qui y mènent : ouvrir la fiche
//   P2026-0187 par la liste, un mail ou la recherche, c'est l'avoir vue.
//
// Pas de cloche pour un fournisseur. Bascule de rôle : celle de la personne
// affichée, en lecture seule.

import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useCurrentUser } from '@/hooks/useCurrentUser'
import { useSurProblemesModifies } from '@/hooks/signalProblemesModifies'
import { notificationsDeLaPage } from '@/utils/cloche'
import { definirLecteurCloche, effacerDeLaCloche, relireCloche, useCloche } from './etat'

const INTERVALLE_MS = 2 * 60_000

export function ChargeurCloche(): null {
  const { user, isFournisseur, enVueRole } = useCurrentUser()
  const upn = user && !isFournisseur ? user.upn : null
  const { pathname } = useLocation()
  const { notifications } = useCloche()
  const derniere = useRef(0)

  useEffect(() => {
    definirLecteurCloche(upn, enVueRole)
    if (!upn) return
    const lire = (): void => {
      derniere.current = Date.now()
      void relireCloche()
    }
    lire()
    const minuterie = window.setInterval(() => {
      if (document.visibilityState === 'visible') lire()
    }, INTERVALLE_MS)
    function surVisibilite(): void {
      if (document.visibilityState === 'visible' && Date.now() - derniere.current >= INTERVALLE_MS) lire()
    }
    document.addEventListener('visibilitychange', surVisibilite)
    return () => {
      window.clearInterval(minuterie)
      document.removeEventListener('visibilitychange', surVisibilite)
    }
  }, [upn, enVueRole])

  useSurProblemesModifies(relireCloche)

  // Ce qui mène à la page ouverte est vu (aussi à l'arrivée d'une notification
  // pour la fiche qu'on a déjà sous les yeux).
  useEffect(() => {
    const vues = notificationsDeLaPage(notifications, pathname)
    if (vues.length > 0) effacerDeLaCloche(vues.map((n) => n.id))
  }, [pathname, notifications])

  return null
}
